// Shared competition metadata (label, trophy image, accent color, group).
// Keep in sync with backend competition keys.

export const COMPETITION_META = {
    // Leagues (current format, seasons 13+)
    league_top: { label: "TOP Division", image: "/trophies/campionato-top.webp", color: "#FFD700", group: "league" },
    league_dop: { label: "DOP Division", image: "/trophies/campionato-dop.webp", color: "#E0E0E0", group: "league" },
    league_ops: { label: "OPS Division", image: "/trophies/campionato-ops.webp", color: "#FF6B00", group: "league" },
    league_hope: { label: "HOPE Division", image: "/trophies/campionato-hope.webp", color: "#00E5FF", group: "league" },
    primavera: { label: "Primavera", image: "/trophies/campionato-primavera.webp", color: "#7C3AED", group: "youth" },
    // Leagues (legacy, seasons 1-12)
    league_serie_a: { label: "Serie A", image: "/trophies/legacy-serie-a.webp", color: "#0066CC", group: "league" },
    league_liga: { label: "Liga", image: "/trophies/legacy-liga.webp", color: "#C60B1E", group: "league" },
    league_premier: { label: "Premier League", image: "/trophies/legacy-premier.webp", color: "#3D195B", group: "league" },
    league_ligue1: { label: "Ligue 1", image: "/trophies/legacy-ligue1.webp", color: "#003F87", group: "league" },
    x_championship: { label: "X-Championship", image: "/trophies/x-championship.webp", color: "#9C27B0", group: "special" },
    // European cups
    champions: { label: "Champions League", image: "/cups/champions.webp", color: "#FFD700", group: "european" },
    europa: { label: "Europa League", image: "/cups/europa.webp", color: "#FF7A1A", group: "european" },
    conference: { label: "Conference League", image: "/cups/conference.webp", color: "#00BCD4", group: "european" },
    // National cups
    coppa_italia: { label: "Coppa Italia", image: "/cups/coppa-italia.webp", color: "#0066CC", group: "national_cup" },
    copa_del_rey: { label: "Copa del Rey", image: "/cups/copa-del-rey.webp", color: "#C60B1E", group: "national_cup" },
    coppa_francia: { label: "Coppa di Francia", image: "/cups/coupe-de-france.webp", color: "#0055A4", group: "national_cup" },
    fa_cup: { label: "FA Cup", image: "/cups/fa-cup.webp", color: "#012169", group: "national_cup" },
    // Supercups
    supercoppa_europea: { label: "Supercoppa Europea", image: "/cups/supercoppa-europea.webp", color: "#1A237E", group: "supercup" },
    supercoppa_italiana: { label: "Supercoppa Italiana", image: "/cups/supercoppa-italiana.webp", color: "#0066CC", group: "supercup" },
    supercoppa_spagna: { label: "Supercoppa di Spagna", image: "/cups/supercopa-espana.webp", color: "#C60B1E", group: "supercup" },
    supercoppa_francia: { label: "Supercoppa di Francia", image: "/cups/trophee-des-champions.webp", color: "#0055A4", group: "supercup" },
    community_shield: { label: "Community Shield", image: "/cups/community-shield.webp", color: "#012169", group: "supercup" },
    // International
    europei: { label: "Europei", image: "/trophies/europei.webp", color: "#2BB6FF", group: "international" },
    // Individual awards (player awards)
    pallone_oro: { label: "Pallone d'Oro", color: "#FFD700", group: "individual" },
    scarpa_oro: { label: "Scarpa d'Oro", color: "#FF7A1A", group: "individual" },
    premio_yashin: { label: "Premio Yashin", color: "#2BB6FF", group: "individual" },
};

export const GROUP_ORDER = ["european", "league", "national_cup", "supercup", "youth", "international", "special", "individual"];

// Etichetta leggibile del "leg" di una singola partita (andata/ritorno/spareggio).
export function matchLegLabel(leg) {
    return {
        "1st_leg": "Andata",
        "2nd_leg": "Ritorno",
        "replay": "Spareggio (Bella)",
        "single": "",
    }[leg] || (leg || "");
}
